import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './components/HomePage';
import QuizPage from './components/QuizPage';
import MovieSelector from './components/MovieSelector';
import UserProfile from './components/UserProfile';
import AuthCallback from './components/AuthCallback';
import Footer from './components/Footer';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className='App'>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/movies' element={<MovieSelector />} />
            <Route path='/quiz/:movieId' element={<QuizPage />} />
            <Route path='/quiz/random/:language' element={<QuizPage />} />
            <Route path='/quiz/popular/:language' element={<QuizPage />} />
            <Route path='/quiz/genz/:language' element={<QuizPage />} />
            <Route path='/profile' element={<UserProfile />} />
            <Route path='/auth/callback' element={<AuthCallback />} />
            <Route path='/auth/error' element={<HomePage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
